import { Box, Grid, Typography } from "@mui/material";
import { limitNumber } from "../../utils/limitNumber";
import { EyeView, ThumbLike } from "../images";
import { PostInfo } from "./types";

const styles = {
  contentWrapper: {
    width: "fit-content",
    mr: "auto",
    justifyContent: "center",
    flex: 1,
  },
  contentTitle: {
    fontSize: "0.875rem",
    fontWeight: "500",
    display: "-webkit-box",
    overflow: "hidden",
    wordBreak: "break-all",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: "2",
  },
  contentInfo: {
    flexWrap: "nowrap",
    alignItems: "end",
    pt: "calc((0.5rem) + 0.5em * 0.5)",
    "& svg": {
      width: "1em",
    },
  },
  contentInfoText: {
    fontSize: "0.75rem",
    fontWeight: "normal",
    color: "brownishGrey",
    lineHeight: "1",
  },
  contentInfoDivider: {
    width: "1px",
    height: "0.688rem",
    borderLeft: "2px solid",
    borderColor: "dividerGrey",
    mx: "4px",
  },
  name: {
    display: "-webkit-box",
    overflow: "hidden",
    wordBreak: "break-all",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: "1",
  },
  date: {
    whiteSpace: "nowrap",
  },
};

interface CafeCardContentProps {
  row: PostInfo;
}

export const CafeCardContent = ({ row }: CafeCardContentProps) => {
  const { title, userName, view, postCreatedAt, like } = row;

  const ContentDivider = () => <Box sx={styles.contentInfoDivider} />;

  return (
    <Grid container direction="column" item sx={styles.contentWrapper}>
      <Grid item sx={styles.contentTitle}>
        {title}
      </Grid>
      <Grid container item sx={styles.contentInfo}>
        <Typography sx={{ ...styles.contentInfoText, ...styles.name }}>
          {userName}
        </Typography>
        <ContentDivider />
        <Typography sx={{ ...styles.contentInfoText, ...styles.date }}>
          {postCreatedAt.slice(2)}
        </Typography>
        <ContentDivider />
        <EyeView transform="translate(0, 1)" style={{ minWidth: "1em" }} />
        <Typography sx={styles.contentInfoText}>
          {limitNumber(view, 999)}
        </Typography>
        <ContentDivider />
        <ThumbLike style={{ minWidth: "1em" }} />
        <Typography sx={styles.contentInfoText}>
          {limitNumber(like, 999)}
        </Typography>
      </Grid>
    </Grid>
  );
};
